import React, { cloneElement } from 'react'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import './DragDropComponent.module.scss'

export default function DragDropComponent({ handleUpdate, droppableId, listItems, draggableKey='id', children }) {

    const handleDragEnd = (item) => {
        const num = listItems.filter(col => col.disabled).length
        if (item.destination && item.destination.index >= num){
            const copy = [...listItems]
            const reOrdered = copy.splice(item.source.index, 1)[0]
            copy.splice(item.destination.index, 0, reOrdered)

            handleUpdate(copy)
        }
    }

    return (
        <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId={droppableId}>
                {(provided) => (
                    <div {...provided.droppableProps} ref={provided.innerRef}>
                        {listItems.map((item, index) => {
                            return (
                                <Draggable key={item[draggableKey] ?? item} draggableId={item[draggableKey] ?? item} index={index} isDragDisabled={item.disabled}>
                                    {(provided) => (
                                        <div {...provided.draggableProps} ref={provided.innerRef}>
                                            {cloneElement(children(item), {dragHandleProps:provided.dragHandleProps})}
                                        </div>)}
                                </Draggable>
                            )
                        })}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    )
}